import { cva } from 'class-variance-authority';
import { useContext } from 'react';

import { mergeClasses } from '@/utils';

import { Checkbox, ITableRow } from '@/components/common';

import TableCell from './TableCell';
import TableContext from './TableContext';
import { isRowSelected } from './Table.utils';

const TABLE_ROW_VARIANTS = cva('bg-neutral-white text-primary-darkest', {
  variants: {
    size: {
      default: 'h-14',
      sm: 'h-12',
      md: 'h-14',
      lg: 'h-16',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

const TableRow = ({ className, rowId, children, ...props }: ITableRow) => {
  const { size, hasCheckBox, checkboxState, onSelectRow, rows } = useContext(TableContext);
  const row = rows?.find((row) => row.id === rowId);
  const isClientSelected = isRowSelected(row, checkboxState?.includes, checkboxState?.excludes);

  return (
    <tr
      data-slot="table-row"
      data-state={isClientSelected ? 'selected' : undefined}
      className={mergeClasses(TABLE_ROW_VARIANTS({ size }), className)}
      {...props}
    >
      {hasCheckBox && row && (
        <TableCell className="text-center [&>div]:align-left">
          <Checkbox
            checked={isClientSelected}
            onClick={() => onSelectRow?.(row.id, !isClientSelected)}
            className="size-6"
          />
        </TableCell>
      )}
      {children}
    </tr>
  );
};

export default TableRow;
